import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import { Icon } from "../icon/icon";

export type FaqAccordionItem = {
  question: string;
  answer: string;
};

export const FaqAccordion = ({
  items,
  className = "",
}: {
  items: FaqAccordionItem[];
  className?: string;
}) => {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <div className={`flex flex-col ${className}`}>
      {items.map((item, idx) => {
        const isOpen = openIndex === idx;

        return (
          <div
            key={item.question}
            className="border-t border-grey-200 first:border-t-0"
          >
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? -1 : idx)}
              className={`flex w-full items-center gap-3 rounded-[14px] py-[18px] text-left transition-all duration-300 ${
                isOpen ? "bg-white px-4" : "pr-4 hover:pl-4"
              }`}
            >
              <p className="flex-1 font-onest text-lg font-semibold tracking-[-0.4px] text-ink sm:text-xl">
                {item.question}
              </p>
              <span className="flex shrink-0 items-center p-1 text-ink">
                <Icon svg={isOpen ? "minus" : "plus"} width={24} height={24} />
              </span>
            </button>

            <AnimatePresence initial={false}>
              {isOpen ? (
                <motion.div
                  key="content"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                  className="overflow-hidden rounded-[14px] bg-white"
                >
                  <div className="px-4 pb-5">
                    <p className="font-onest text-base leading-[26px] tracking-[-0.36px] text-ink sm:text-lg">
                      {item.answer}
                    </p>
                  </div>
                </motion.div>
              ) : undefined}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};
